import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store/index';

Vue.config.productionTip = false

import common from '@/mixins/common'
Vue.mixin(common);

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
